import App from "./Components/App";
import ReactDOM from "react-dom/client";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
//fonts
import "./assets/fonts/ArtegraSansAlt-Black.ttf";
import "./assets/fonts/ArtegraSansAlt-Light.ttf";
import "./assets/fonts/ArtegraSansAlt-ExtraBold.ttf";
import "./assets/fonts/ArtegraSansAlt-Bold.ttf";
import "./assets/fonts/ArtegraSansAlt-Medium.ttf";
import "./assets/fonts/ArtegraSansAlt-SemiBold.ttf";
import "./assets/fonts/ArtegraSansAlt-Regular.ttf";
import "./assets/fonts/ArtegraSansAlt-Thin.ttf";

import "./index.css";
import { LoadingProvider } from "./context/loadingContext";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider, message } from "antd";
import { theme } from "./theme";

message.config({
  // top: window.innerHeight - 100,
  duration: 3,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <CssBaseline />
    <LoadingProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ConfigProvider
            theme={theme}
          >
            <App />
          </ConfigProvider>
        </PersistGate>
      </Provider>
    </LoadingProvider>
  </>
);
